// Thin fetch wrapper for the Kinmantle API. All widget data flows through
// the hooks in queries.ts, never through direct provider calls.

export class ApiRequestError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code: string,
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init: { method?: string; body?: unknown; signal?: AbortSignal } = {}): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api${path}`, {
      method: init.method ?? "GET",
      credentials: "same-origin",
      signal: init.signal,
      headers: {
        accept: "application/json",
        // Required on every mutating request (CSRF guard in the Worker).
        "x-kinmantle": "1",
        ...(init.body !== undefined ? { "content-type": "application/json" } : {}),
      },
      body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
    });
  } catch {
    throw new ApiRequestError("You appear to be offline.", 0, "OFFLINE");
  }
  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    let code = "HTTP_ERROR";
    try {
      const body = (await res.json()) as { error?: string; code?: string };
      if (body.error) message = body.error;
      if (body.code) code = body.code;
    } catch {
      /* non-JSON error body */
    }
    throw new ApiRequestError(message, res.status, code);
  }
  return (await res.json()) as T;
}
